import {
  useMemo,
  forwardRef,
} from "react"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { useGetGlucoseValueAsPercentage } from "../hooks"
import { useFollowedUsers } from "src/contexts"

type Props = ComponentPropsWithoutRef<"div">

export const UrgentLow = forwardRef<HTMLDivElement, Props>(
  function UrgentLow(props: Props, propsRef: Ref<HTMLDivElement>) {
    const { currentFollow } = useFollowedUsers()
    const getGlucoseValueAsPercentage = useGetGlucoseValueAsPercentage()
    const urgentLow = currentFollow.display_settings.urgent_low

    const [
      urgentLowPercentage,
      urgentLowClamped,
    ] = getGlucoseValueAsPercentage(urgentLow)

    const urgentLowStyles = useMemo(
      () => ({
        bottom: `${urgentLowPercentage}%`,
      }),
      [urgentLowPercentage],
    )

    if (urgentLowClamped) {
      return null
    }

    return (
      <div
        id="urgent-low-line"
        {...props}
        ref={propsRef}
        style={urgentLowStyles}
      />
    )
  },
)
